module.exports = __webpack_public_path__ + "static/img/buttonBg.d4e58ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttonBg.png
// module id = qTPa
// module chunks = 1